import {
  productIdFormat,
  purchaseOrderIdFormat,
  supplierIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const createPurchaseOrder = {
  name: "createPurchaseOrder" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema.optional(),
    fulfillmentGroupId: z.string().optional(),
    products: z
      .array(
        z.object({
          productId: productIdFormat.schema,
          quantity: z.number().int().min(0),
          receivedQuantity: z.number().int().min(0).default(0),
          damagedQuantity: z.number().int().min(0).default(0),
          unitCost: z.number().min(0).default(0),
          costCurrency: z.string().default("USD"),
          totalTax: z.number().min(0).default(0),
          taxCurrency: z.string().default("USD"),
        }),
      )
      .optional(),
  }),
  output: z.object({ purchaseOrderId: purchaseOrderIdFormat.schema }),
};
